var _excluded = ["border", "children", "contentId", "description", "expanded", "heading", "headingCollapsed", "headingAs", "headingId", "icon", "iconColor", "size", "triggerCallback"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import * as IconSet from "../../../icons/index.js";
import Icon from "../../basic/Icon/Icon.js";
var AccordionIcon = styled(Icon).withConfig({
  componentId: "CL__sc-1rohdhn-0"
})(["flex:1 0 auto;margin-right:var(--spacing-1);padding-top:", ";"], _ref => {
  var {
    size
  } = _ref;
  return size === 18 ? '3px' : '0';
});
var AccordionHeading = styled.h1.withConfig({
  componentId: "CL__sc-1rohdhn-1"
})(["font:var(--body-text-", ");font-weight:600;text-align:left;margin:0;padding:0 var(--spacing-2) 0 0;width:100%;display:-webkit-box;", ""], _ref2 => {
  var {
    size
  } = _ref2;
  return size;
}, _ref3 => {
  var {
    expanded
  } = _ref3;
  return !expanded ? css(["text-overflow:ellipsis;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden;"]) : "";
});
var AccordionIndicator = styled(Icon).withConfig({
  componentId: "CL__sc-1rohdhn-2"
})(["transition:transform var(--hover-transition) var(--transition-easing);flex:1 0 auto;padding-top:", ";"], _ref4 => {
  var {
    expanded,
    size
  } = _ref4;
  return size === 18 && !expanded ? '3px' : '0';
});
var AccordionHeadingLayout = styled.div.withConfig({
  componentId: "CL__sc-1rohdhn-3"
})(["display:flex;width:100%;align-items:flex-start;"]);
var AccordionDescription = styled.span.withConfig({
  componentId: "CL__sc-1rohdhn-4"
})(["font:var( --body-text-", " );text-align:left;color:var(--text-color-dim);width:100%;display:-webkit-box;", ""], _ref5 => {
  var {
    size
  } = _ref5;
  return size === 'medium' ? 'small' : 'x-small';
}, _ref6 => {
  var {
    expanded
  } = _ref6;
  return !expanded ? css(["text-overflow:ellipsis;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden;"]) : "";
});
var AccordionTrigger = styled.button.attrs({}).withConfig({
  componentId: "CL__sc-1rohdhn-5"
})(["background:transparent;display:flex;flex-direction:column;justify-content:center;width:100%;min-height:var(--spacing-8);cursor:pointer;border:none;box-shadow:none;transition:background-color 150ms;border-radius:var(--border-radius-small);padding:var(--spacing-1);margin:0;appearance:none;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;&::-moz-focus-inner{border:0;padding:0;margin-top:-2px;margin-bottom:-2px;}", "{color:var(--text-color);}", "{color:var(--text-color-dim);}&:hover,&:focus-visible{background:var(--gray-2);", ",", "{color:var(--purple-core);}}[data-theme='dark'] &:hover,[data-theme='dark'] &:focus-visible{background:var(--purple-7);", ",", "{color:var(--mint-core);}}&:active{background:var(--gray-3);", ",", "{color:var(--purple-8);}}[data-theme='dark'] &:active{background:var(--purple-8);", ",", "{color:var(--mint-core);}}&:focus{outline:none;}"], AccordionHeading, AccordionIndicator, AccordionHeading, AccordionIndicator, AccordionHeading, AccordionIndicator, AccordionHeading, AccordionIndicator, AccordionHeading, AccordionIndicator);
var AccordionContent = styled.div.withConfig({
  componentId: "CL__sc-1rohdhn-6"
})(["transition:opacity 300ms ease-out;", ""], _ref7 => {
  var {
    expanded
  } = _ref7;
  return expanded ? css(["opacity:1;padding:var(--spacing-1);visibility:visible;"]) : css(["height:0;opacity:0;overflow:hidden;pointer-events:none;visibility:hidden;"]);
});
var AccordionContainer = styled.div.withConfig({
  componentId: "CL__sc-1rohdhn-7"
})(["--accordion-transition:300ms ease-out;border-radius:var(--border-radius-small);", " & + &{margin-top:var(--spacing-2);}", "{transform:", ";}"], _ref8 => {
  var {
    border
  } = _ref8;
  return border ? css(["background:var(--modal-bkg-color);border:1px solid var(--border-color-dim);padding:var(--spacing-1);"]) : "";
}, AccordionIndicator, _ref9 => {
  var {
    expanded
  } = _ref9;
  return expanded ? 'scaleY(-1)' : 'none';
});
var Accordion = /*#__PURE__*/React.forwardRef((_ref10, ref) => {
  var {
      border = false,
      children = '',
      contentId,
      description,
      expanded = false,
      heading,
      headingCollapsed,
      headingAs = 'h1',
      headingId,
      icon,
      iconColor = 'var(--highlight-color)',
      size = 'medium',
      triggerCallback
    } = _ref10,
    props = _objectWithoutProperties(_ref10, _excluded);
  var [isExpanded, setIsExpanded] = useState(expanded);
  return /*#__PURE__*/React.createElement(AccordionContainer, _extends({
    border: border,
    contentId: contentId,
    expanded: isExpanded,
    heading: heading,
    ref: ref,
    size: size
  }, props), /*#__PURE__*/React.createElement(AccordionTrigger, {
    "aria-controls": contentId,
    "aria-expanded": isExpanded,
    id: "".concat(contentId, "-trigger"),
    onClick: event => {
      var newExpanded = !isExpanded;
      setIsExpanded(newExpanded);
      triggerCallback === null || triggerCallback === void 0 ? void 0 : triggerCallback(newExpanded, event);
    },
    size: size,
    tabIndex: 0,
    type: "button"
  }, /*#__PURE__*/React.createElement(AccordionHeadingLayout, null, icon && /*#__PURE__*/React.createElement(AccordionIcon, {
    color: iconColor,
    component: icon,
    size: size === 'small' ? 18 : 24
  }), /*#__PURE__*/React.createElement(AccordionHeading, {
    as: headingAs,
    expanded: isExpanded,
    id: headingId || "".concat(contentId, "-heading"),
    size: size
  }, headingCollapsed && !isExpanded ? headingCollapsed : heading), /*#__PURE__*/React.createElement(AccordionIndicator, {
    component: IconSet.ChevronDown,
    expanded: isExpanded,
    size: size === 'small' ? 18 : 24
  })), description && /*#__PURE__*/React.createElement(AccordionDescription, {
    expanded: isExpanded,
    size: size
  }, description)), /*#__PURE__*/React.createElement(AccordionContent, {
    "aria-hidden": !isExpanded,
    expanded: isExpanded,
    id: contentId
  }, children));
});
export default Accordion;